import { NavLink as MenuItem, Tooltip } from '@mantine/core';
import { HTMLAttributeAnchorTarget, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { P2Regular } from 'theme/typography';

/**
 * The parameters of the NavbarItem.
 */
export interface NavbarItemProps {
  isCollapsed?: boolean;
  to: string;
  label?: string | React.ReactNode;
  icon?: React.ReactNode;
  target?: HTMLAttributeAnchorTarget;
  alwaysShowLabel?: boolean;
}

/**
 * An item in the navbar.
 */
export default function NavbarItem({ isCollapsed, to, icon, label, target, alwaysShowLabel }: NavbarItemProps) {
  const styles = useMemo(
    () => ({
      label: {
        display: isCollapsed && !alwaysShowLabel ? 'none' : 'initial',
        ...(isCollapsed && alwaysShowLabel ? P2Regular : {}),
      },
      icon: { marginRight: isCollapsed ? '0 !important' : '24px' },
      body: { width: isCollapsed ? '80%' : '100%' },
    }),
    [alwaysShowLabel, isCollapsed]
  );

  return (
    <NavLink
      target={target}
      tabIndex={-1}
      to={to}
      style={{
        textDecoration: 'none',
      }}
      className={isCollapsed ? 'collapsed' : ''}
    >
      {({ isActive }) => (
        <Tooltip withinPortal position="right" withArrow={false} label={label} openDelay={isCollapsed ? 200 : 10 ** 7}>
          <MenuItem
            active={isActive}
            icon={icon}
            label={isCollapsed && !alwaysShowLabel ? '' : label}
            styles={styles}
            className={isCollapsed ? 'collapsed' : ''}
          />
        </Tooltip>
      )}
    </NavLink>
  );
}
